import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2b0b9a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap" }

import {FilterDisplayItemExtended, StorageStore} from '@/store/types';
import {computed} from 'vue';
import {PropType} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterList',
  props: {
  store: {
    type: Object as PropType<StorageStore<any, any, any>>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const displayFilters = computed((): FilterDisplayItemExtended[] => {
  return props.store.displayFilters;
});

function remove(filter: FilterDisplayItemExtended) {
  props.store.unsetFilter(filter);
}

__expose({
  remove,
  displayFilters,
  props,
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayFilters.value, (filterValue, i) => {
      return (_openBlock(), _createBlock(_component_v_chip, {
        key: i,
        color: "",
        size: "small",
        class: "ma-1",
        closable: "",
        "close-icon": "mdi-close",
        "onClick:close": ($event: any) => (remove(filterValue))
      }, _createSlots({
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(filterValue.text), 1)
        ], undefined, true),
        _: 2
      }, [
        (filterValue.color)
          ? {
              name: "prepend",
              fn: _withCtx(() => [
                _createVNode(_component_v_chip, {
                  class: "filter-status-color ml-n2 me-2",
                  variant: "flat",
                  color: filterValue.color,
                  size: "x-small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      class: "filter-status-icon",
                      size: "small",
                      color: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-" + _toDisplayString(filterValue.icon), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024)
                  ], undefined, true),
                  _: 2
                }, 1032, ["color"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["onClick:close"]))
    }), 128))
  ]))
}
}

})